// extracted by mini-css-extract-plugin
export default {"progress":"slider_progress__GmUjk"};